// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Pd","title":"Qd","nav":"Rd","flexCell":"Sd","facetLink":"Td"};